const printType = {}

printType.install = function (Vue) {
  Vue.filter('print-type', (value) => {
    if (value === 2) {
      return 'Scheduled Groups'
    }
    if (value === 18) {
      return 'Custom'
    }
    return ''
  })
}

export default printType
